module.exports = __webpack_public_path__ + "static/d-and-a-d-logo-e9f614828de9ac3fb1e0e2371f7d5e52.png";